import { owaspLlmToDisplayName } from 'src/app/common/violationRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const OwaspLlmSelectOptionAll: ISelectOption = {
  id: `${FilterTypesEnum.OwaspLlm.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.OwaspLlm,
  categoryName: FilterTypesEnum.OwaspLlm.toString(),
};

export const OwaspLlmSelectOptions: ISelectOption[] = Object.keys(owaspLlmToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.OwaspLlm.toString()}-${attackKey}`,
      value: attackKey,
      displayName: owaspLlmToDisplayName[attackKey],
      filterType: FilterTypesEnum.OwaspLlm,
      categoryName: FilterTypesEnum.OwaspLlm.toString(),
    }) as ISelectOption
);
